import ReactDataTable from 'react-data-table-component';
import { shouldShowDataTablePagination } from '@/Components/Common/dataTablePagination';

/**
 * Drop-in replacement for `react-data-table-component` default export.
 * Applies app-wide rule: pagination UI only when record count &gt; {@link DATA_TABLE_PAGINATION_THRESHOLD}.
 *
 * - Client tables: uses `data.length`
 * - Server tables: uses `paginationTotalRows` when `paginationServer` or `paginationTotalRows` is set
 *
 * Pass `pagination={false}` to disable pagination entirely (wrapper respects this).
 */
function resolveRecordCount(props) {
    const { data, paginationTotalRows, paginationServer } = props;
    const serverish = Boolean(paginationServer) || paginationTotalRows != null;
    if (serverish) {
        const n = paginationTotalRows != null ? Number(paginationTotalRows) : NaN;
        if (Number.isFinite(n)) return n;
    }
    return Array.isArray(data) ? data.length : 0;
}

export default function DataTableWithAutoPagination(props) {
    const {
        pagination: paginationIn,
        paginationServer: paginationServerIn,
        ...rest
    } = props;

    if (paginationIn === false) {
        return <ReactDataTable {...props} />;
    }

    const count = resolveRecordCount(props);
    const show = shouldShowDataTablePagination(count);
    const serverish = Boolean(props.paginationServer) || props.paginationTotalRows != null;

    return (
        <ReactDataTable
            {...rest}
            pagination={show}
            paginationServer={serverish ? show : false}
            showPaginationBottom={show}
        />
    );
}
